import { FilterRuleData } from "./filter-rule.types";

export class FilterRule implements FilterRuleData {
  readonly condition?: string;
  readonly field?: string;
  readonly id?: string;
  readonly input?: string;
  readonly operator?: string;
  rules?: FilterRule[];
  readonly type?: string;
  readonly value?: object;

  constructor(data: FilterRuleData) {
    this.condition = data.condition || "and";
    this.field = data.field;
    this.id = data.id;
    this.input = data.input;
    this.operator = data.operator;
    this.type = data.type;
    this.value = data.value;

    this.rules = data.rules?.map(rule => new FilterRule(rule));
  }
}
